<template>
  <div v-if="section" class="container-fluid">
    <div v-for="attribute in errors" class="alert alert-danger" :key="attribute.field">
      {{attribute.value}}
    </div>
    <h4 class="m-3">Изменение раздела FAQ</h4>
    <el-form      
      label-width="120px"
      id="uploadForm"
      name="uploadForm"
      enctype="multipart/form-data"
    >
      <el-form-item label="Название">
        <el-input v-model="section.title"></el-input>
      </el-form-item>
      <el-form-item label="Сортировка">
        <el-input v-model="section.sort"></el-input>
      </el-form-item>
      <el-form-item label="Активность">
        <el-checkbox v-model="section.activity"></el-checkbox>
      </el-form-item>

      <el-form-item label="Иконка">
        <el-row>
          <el-col :span="12">
            <el-select   
            v-model="section.iconId"             
            placeholder="Выберите иконку"
            :style="{width: '100%', maxWidht: '100%'}"
            >
              <el-option
              v-for="it in getIcons"
              :key="it.id"
              :value="it.id"
              :label="it.alt || it.id"    
              >
              <el-row>
                <el-col :span="3"><el-image style="width: 34px; height: 34px" :src="it.path" fit="cover" /></el-col>
                <el-col :span="4"><span>{{it.alt || it.id}}</span></el-col>
              </el-row>                    
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button @click="$store.commit('iconDialog',true)">Добавить иконку</el-button>
          </el-col>
        </el-row>
       
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="storeSection">Изменить</el-button>
        <el-button @click="back">Отмена</el-button>
      </el-form-item>
    </el-form>
    <el-row v-if="section.id">
      <Faqs :update="true" :section-id="section.id"></Faqs>
    </el-row>    
    <icon-dialog ></icon-dialog >
  </div>
</template>

<script>
import axios from "axios";
import Faqs from "@/components/Faq/Faqs";
import { SETPRELOADER_STATE } from "@/store/mutation-types";
import IconDialog from '@/components/Icon/AddIconDialog';
import useFormData from '../../composable/useFormData';
import getErrors from '../../composable/utils/getErrors';

export default {
  components: { Faqs, IconDialog },
  data: function () {
    return {
      section: {
        title: '',
        slug: '',
        sort: 0,
        activity: false,
        iconId: -1,
        id: 0,
      },
      errors: [],
      status: 0,
      popups: [],
      updateQuestion: false,
      updateFaqId: null,
      isLoad: false,
    };
  },
  computed: {
    getIcons() {
        return this.$store.state.IconDialog.generalIcons
    },
  },
  mounted() {
    this.changeIcon = false;
    this.fetch();
  },
  methods: {
    fetch() {
      const id = this.$route.params.id;
      this.$store.commit(SETPRELOADER_STATE, true);

      axios.get(`faq/section/${id}`)
      .then((response) => {
        this.initValues(response.data)
      })
      .catch(() => {})
      .finally(() => (this.$store.commit(SETPRELOADER_STATE, false)))

    },
    back() {
      this.$router.push("/faq-sections");
    },
    storeSection() {
      const { execute } = useFormData()

      const data = execute().setFields([
        'title',        
        'iconId',
        'sort',
        'activity',
      ]).getFormData(this.section)

      axios
        .post(`/faq/section/${this.section.id}`, data)
        .then((response) => {
          this.status = response.status;
          this.$router.push("/faq-sections");
        })
        .catch((errors) => {
          if (errors.response.status === 401) {
            this.$router.push("/login");
          }

          this.errors = getErrors(errors.response.data.errors);
        });
    },
    initValues(value) {      
      if (value) {
        this.section.title = value.title || '';
        this.section.slug = value.slug || '';
        this.section.sort = value.sort || '';
        this.section.activity = value.activity || '';
        this.section.iconId = value.icon_id || '';
        this.section.id = value.id || -1;
      }        
    }
  },
};
</script>

<style scoped>
.section-questions__wrapper {
  display: flex;
  flex-direction: column;
}

.questions__content {
  margin-left: -120px;
}
</style>